import React from "react";
import { Table } from "react-bulma-components";
import { formatDate, readableDate } from "../../utils";
import { Heading } from "react-bulma-components";

class PrintInvoice extends React.Component {
  get totalPartCost() {
    if (Object.entries(this.props.data).length < 1) return 0;

    return Object.entries(this.props.data).reduce((total, work) => {
      return (
        work[1].parts.reduce((work_total, part) => {
          return ( Math.round( (work_total + part.customer_cost) *100) ) /100;
        }, 0) + total
      );
    }, 0);
  }

  get totalCost() {
    if (Object.entries(this.props.data).length < 1) return 0;
    return Object.entries(this.props.data).reduce((total, work) => {
      return (Math.round((total + work[1].customer_labour_cost)* 100))/100;
    }, 0);
  }

  get totalWithVAT() {
    return (Math.round(((this.totalCost + this.totalPartCost) *1.2) *100)) / 100;
  }

  PartRow(part) {
    return (
      <tr key={part.id}>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{part.name}</td>
        <td>
          £
          {(part.customer_cost || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </td>
      </tr>
    );
  }

  WorkRow(work) {
    let rows = [];
    rows.push(
      <tr key={work.id} className="table-highlight-orange">
        <td>{work.job}</td>
        <td>{readableDate(work.finish_date)}</td>
        <td>{work.vehicle_registration}</td>
        <td>{work.description}</td>
        <td>
          £
          {(work.customer_labour_cost || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </td>
        <td>{work.workshop}</td>
        <td>{work.chargeable ? work.customer2 : work.customer}</td>
        <td></td>
        <td></td>
      </tr>
    );
    rows = rows.concat(work.parts.map(part => this.PartRow(part)));
    return rows;
  }

  render() {
    return (
      <div className="print-background">
        <Heading>Customer Invoice</Heading>
        <Table>
          <thead>
            <tr>
              <td>Total Labour:</td>
              <td>Total Parts:</td>
              <td>Total Labour and Parts:</td>
              <td>Total Inc. VAT</td>
              <td>Invoice Date</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                £
                {(this.totalCost || 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
              <td>
                £
                {(this.totalPartCost || 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
              <td>
                £
                {(this.totalPartCost + this.totalCost || 0).toLocaleString(
                  undefined,
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }
                )}
              </td>
              <td>
                £
                {(this.totalWithVAT || 0).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
              <td>
                {readableDate(formatDate(new Date(this.props.paymentDate)))}
              </td>
            </tr>
          </tbody>
        </Table>
        <Table>
          <thead>
            <tr>
              <td>Job ID</td>
              <td>Date</td>
              <td>Registration</td>
              <td>Description</td>
              <td>Labour Cost</td>
              <td>Workshop</td>
              <td>Customer</td>
              <td>Part Name</td>
              <td>Part Cost</td>
            </tr>
          </thead>
          <tbody>
            {Object.entries(this.props.data)
              .sort(
                (a, b) =>
                  new Date(a[1].finish_date) - new Date(b[1].finish_date)
              )
              .map(entry => this.WorkRow(entry[1]))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default PrintInvoice;
